import { Component, Output, EventEmitter, ViewChildren, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MediaService } from '../../shared-services/media.service';

export interface ISelectedChip {
  chipKey: string;
  chipLabel: string;
  categoryName: string;
  typeId: any;
  selectedChipFilterComponent: any;
}

export interface RoleFiltersChange {
  chips: ISelectedChip[];
}


@Component({
  selector: 'app-role-filter',
  styleUrls: ['./role-filter.component.scss'],
  templateUrl: './role-filter.component.html',
})
export class RoleFilterComponent implements OnInit, OnChanges {
  isMobile: boolean;

  @Output() filtersChanged = new EventEmitter<RoleFiltersChange>();
  @Output() onChipRemove = new EventEmitter<ISelectedChip[]>();
  @Output() onHide = new EventEmitter<void>();

  selectedChips: ISelectedChip[] = [];
  selectedHasDataFilters: number[];

  showDateAfterFilter: boolean;
  showDateBeforeFilter: boolean;

  constructor(
    private mediaService: MediaService,
  ) {}

  ngOnInit() {
    this.mediaService.isMobile.subscribe(isMobile => this.isMobile = isMobile);
  }

  ngOnChanges(changes: SimpleChanges) {}

  onRemoveChip(selectedChip: ISelectedChip) {
    this.selectedChips = this.selectedChips.filter(x => x.chipKey !== selectedChip.chipKey);
    this.onChipRemove.emit(this.selectedChips);
  }

  onTogglePickerFrom(event: any) {
    event.stopPropagation();
  }

  onTogglePickerTo(event: any) {
    event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./src/app/security/role/role-filter.component.ts